<template>
<div
    v-if="answer"
    class="form-submission-card-content-child"
>
    <!--Text Field-->
    <response-text
        v-if="isQuestionType('free_text')"
        :question="question_text"
        :answer="answer.answer"
        is_nested
    />

    <!--Option (dropdown) -->
    <response-dropdown
        v-else-if="isQuestionType(['dropdown', 'dropdown_other'])"
        :question="question_text"
        :answer="answer"
        is_nested
    />

    <!--Options (checkbox) -->
    <response-checkbox
        v-else-if="isQuestionType(['checkbox', 'checkbox_other'])"
        :question="question_text"
        :answer="answer"
        is_nested
    />

    <!-- Date -->
    <response-text
        v-else-if="isQuestionType('date')"
        :question="question_text"
        :answer="answer.answer_formatted"
        is_nested
    />

    <!-- Unsupported -->
    <response-text
        v-else
        question=""
        answer="Question not supported"
        is_nested
    />

    <!-- Comments -->
    <response-comments
        v-if="answer.comment"
        :comments="answer.comment"
        is_nested
    />

    <!-- Images -->
    <gallery-view-component
        v-if="answer.images && Object.keys(answer.images).length >= 1"
        :photos="answer.images"
    />
</div>

<response-text
    v-else
    question=""
    answer="No Answer Data"
/>
</template>

<script>
import GalleryViewComponent from "../general_components/GalleryViewComponent";
import ResponseOptions from "./responses/ResponseOptions.vue";
import ResponseComments from "./responses/ResponseComments.vue";
import ResponseQuestion from "./responses/ResponseQuestion.vue";
import ResponseOptionFreeText from "./responses/ResponseOptionFreeText.vue";
import ResponseText from "./responses/ResponseText.vue";
import ResponseDropdown from "./responses/ResponseDropDown.vue";
import ResponseCheckbox from "./responses/ResponseCheckbox.vue";

export default {
    components: {
        GalleryViewComponent,
        ResponseOptions,
        ResponseComments,
        ResponseQuestion,
        ResponseOptionFreeText,
        ResponseText,
        ResponseDropdown,
        ResponseCheckbox,
    },
    props: {
        answer: {
            type: Object,
            required: true,
        },
    },
    methods: {
        isQuestionType(types) {
            if (!Array.isArray(types)) {
                types = [types];
            }

            return types.includes(this.answer.question.type);
        },
    },
    computed: {
        question_text() {
            return this.answer.question.question;
        },
    },
};
</script>
